import { Button, TextField } from '@resiliatech/birdsong'
import { useState } from 'react'
import { SectionTitle } from './NeedProfilerInfo.styled'
import { IntakeFlowStep } from '../../constants'
import {
  ActionContainer,
  Container,
  InputSection,
} from '../../IntakeFlow.styled'

type Props = {
  onNextStep: (nextStep: IntakeFlowStep) => void
  onBackStep: () => void
  onMoreProfileInfoSave: (websiteUrl: string, ein: string) => void
  ein?: string
  websiteUrl?: string
}

export const NeedProfilerInfo = ({
  onNextStep,
  onBackStep,
  onMoreProfileInfoSave,
  ein = '',
  websiteUrl = '',
}: Props) => {
  const [userWebsiteUrl, setwebsiteUrl] = useState(websiteUrl)
  const [userEin, setEin] = useState(ein)

  const handleNext = () => {
    onMoreProfileInfoSave(userWebsiteUrl, userEin)
    onNextStep(IntakeFlowStep.TOP_PRIORITIES)
  }

  return (
    <Container>
      <InputSection>
        <SectionTitle>Employer Identification Number (EIN)</SectionTitle>
        <TextField
          placeholder='Employer Identification Number (EIN)'
          name='ein'
          variant='outlined'
          defaultValue={ein}
          fullWidth
          onChange={(e) => setEin(e.target.value)}
        />
      </InputSection>
      <InputSection>
        <SectionTitle>Website</SectionTitle>
        <TextField
          placeholder='Website'
          name='website'
          variant='outlined'
          defaultValue={websiteUrl}
          fullWidth
          onChange={(e) => setwebsiteUrl(e.target.value)}
        />
      </InputSection>
      <ActionContainer>
        <Button variant='text' onClick={onBackStep}>
          Back
        </Button>
        <Button
          variant='primary'
          type='submit'
          label='Next'
          onClick={handleNext}
        />
      </ActionContainer>
    </Container>
  )
}
